// extracted by mini-css-extract-plugin
export default {"button":"heOBVClj","qrScannerButton":"qduFjDA3"};